import { Component, ElementRef, Input, OnChanges } from '@angular/core';

import { environment } from '../../../environments/environment';
import { ContentItem, ContentItemType } from '../../helpers/page';

import { DocsService } from '../../services/docs.service';
import { SnippetService } from '../../services/snippet.service';

declare var lightGallery: any;
declare var lgData: any;

@Component({
    selector: 'kd-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnChanges {

    @Input()
    content: string;

    contentItemType: typeof ContentItemType = ContentItemType;
    items: Array<ContentItem>;
    snippetCredentialClass: string = environment.snippetCredentialClass;
    snippetCredentialTemplateId: string = environment.snippetCredentialTemplateId;

    constructor(
        private docsService: DocsService,
        private elementRef: ElementRef,
        private snippetService: SnippetService,
    ) { }

    ngOnChanges() {
        this.items = this.docsService.getContentItems(this.content);

        setTimeout(() => { // let Angular render DOM firstly
            this.initAnchor();
            this.initGallery();
        });
    }

    private initAnchor(): void {
        const scrollContainer: HTMLElement = document.querySelector(environment.scrollContainer);
        scrollContainer.scrollTop = 0;

        if (location.hash) {
            const id: string = location.hash.slice(1);
            const target: HTMLElement = document.getElementById(id);

            if (target) {
                target.scrollIntoView();
            }
        }
    }

    private initGallery(): void {
        const lightgalleryId: string = this.elementRef.nativeElement.getAttribute('lg-uid');

        if (lightgalleryId) {
            // re-init lightgallery
            lgData[lightgalleryId].destroy(true);
        }

        lightGallery(this.elementRef.nativeElement, environment.lightGalleryConfig);
    }

    onSnippetClick(event: Event): void {
        this.snippetService.handleClick(event);
    }

    onSnippetOver(event: Event): void {
        this.snippetService.handleOver(event);
    }
}
